import type { PrefetchedDataGql } from '@atlassian/jira-software-backlog-load-agility-graphql-data/src/types.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_NEXTGEN_BACKLOG } from '../../constants.tsx';

export const backlogResource = createResource<PrefetchedDataGql | null>({
	type: RESOURCE_TYPE_NEXTGEN_BACKLOG,
	getKey: ({ match }) => match.params.boardId || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-nextgen-common", jiraSpaEntry: "async-nextgen-common" */ '../get-data'
		),
	// SSR doesn't care about this and we can't check FFs here because its not in the render path
	maxAge: 1000 * 60 * 60, // 1 hour max age
	isBrowserOnly: true,
});
